import React from 'react';
import '../sass/pages/_price_boxes.scss';

const PriceBoxes = ({ id, title, price, list }) => {
    return (
        <div className="price-boxes" key={id}>
            <div className="price-boxes__txt">
                <span>{title}</span>
                <p>€ ${price}</p>
            </div>
            <ul className='price-boxes__el'>
                {list.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
        </div>
    )
}
export default PriceBoxes;